import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_POPUP_CONTENT, UPDATE_POPUP_CONTENT } from "../type";

// Get Popup Content
export const fetchPopupContent = () => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SETTING;
        console.log(apiEndpoint)
        const response = await JsonInterceptor.get(`${apiEndpoint}`)
        dispatch({
            type: GET_POPUP_CONTENT,
            payload: response.data.data[0],
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Update Popup Content
export const updatePopupContent = (data, id) => async (dispatch) => {
     
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_SETTING;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: UPDATE_POPUP_CONTENT,
            payload: response.data,
        });
        
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_POPUP_CONTENT,
                payload: error.response.data,
            });

            return error.response.data;
        }
    }
};
 